<template>
    <div class="dashboard-container">
      <header>
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
      </header>
      
      <!-- Asset Summary Cards -->    
      <div class="asset-cards-container">
        <template v-if="company === 'SDAA'">
          <div class="asset-card sdaa-card" @click="goToTagListWithFilter('73_')">
            <div class="card-header sdaa-card-header">73</div>
          </div>
          <div class="asset-card sdaa-card" @click="goToTagListWithFilter('74_')">
            <div class="card-header sdaa-card-header">74</div>
          </div>
          <div class="asset-card sdaa-card" @click="goToTagListWithFilter('83_')">
            <div class="card-header sdaa-card-header">83</div>
          </div>
        </template>
        <template v-else>
        <div class="asset-card" @click="goToAssetPage('all')">
          <div class="card-header">Total Asset</div>
          <div class="card-value">{{ totalAssets }}</div>
        </div>
        <div class="asset-card" @click="goToAssetPage('active')">
          <div class="card-header">Active Assets</div>
          <div class="card-value">{{ activeAssets }}</div>
        </div>
        <div class="asset-card" @click="goToAssetPage('inactive')">
          <div class="card-header">Inactive Assets</div>
          <div class="card-value">{{ inactiveAssets }}</div>
        </div>
        </template>
      </div>
  
      <!-- Chart and Map Cards -->
      <div class="chart-map-cards-container">
        <!-- Asset Map Card -->
        <div class="chart-map-card clickable-card" @click="goToAssetMap">
          <div class="card-header">Asset Map</div>
          <div class="dashboard-map-container">
            <AssetMapComponent v-if="company !== 'SDAA'" :dashboardMode="true" />
            <AssetMapSDAA v-if="company === 'SDAA'" :dashboardMode="true" />
          </div>
        </div>
        
        <!-- Asset Chart Card -->
        <div class="chart-map-card">
          <div class="card-header">Asset Chart</div>
          <div class="chart-container">
            <canvas ref="pieChart"></canvas>
          </div>
        </div>
      </div>
  
      <!-- TagList and Gateway Cards -->
      <div class="chart-map-cards-container">
        <!-- TagList Card -->
        <div class="chart-map-card clickable-card" @click="goToTagList">
          <div class="card-header">Tag List</div>
          <div class="dashboard-component-container">
            <TagListComponent class="dashboard-mode" :dashboardMode="true" />
          </div>
        </div>
        
        <!-- Gateway Card -->
        <div class="chart-map-card clickable-card" @click="goToGatewayList">
          <div class="card-header">Gateway</div>
          <div class="dashboard-component-container">
            <GatewayComponent class="dashboard-mode" :dashboardMode="true" />
          </div>
        </div>
      </div>
      
      <!-- 사이드바 추가 -->
      <EventTagSidebar
        v-if="isSidebarVisible"
        :visible="isSidebarVisible"
        :asset="selectedAsset"
        @close="closeSidebar"
      />
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import EventTagSidebar from '../components/EventTagSidebar.vue';
  import { Chart } from 'chart.js/auto';
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  import AssetMapComponent from './AssetMapComponent.vue';
  import AssetMapSDAA from './AssetMapSDAA.vue';
  import TagListComponent from './TagList_old.vue';
  import GatewayComponent from './GatewayList.vue';
  
  Chart.register(ChartDataLabels);
  
  export default {
    name: 'DashboardPage',
    components: {
      EventTagSidebar,
      AssetMapComponent,
      AssetMapSDAA,
      TagListComponent,
      GatewayComponent,
    },
    data() {
      return {
        // companyLogo: require('@/assets/KAVALAN_LOGO.png'), 
        companyLogo: this.getCompanyLogo(), 
        whisky: require('@/assets/kavalanbottles.png'),
        company: localStorage.getItem('company'),
        totalAssets: 0,
        activeAssets: 0,
        inactiveAssets: 0,
        highTempAssets: 0,
        lowTempAssets: 0,
        lowBatteryAssets: 0,
        events: [],
        selectedAsset: null,
        isSidebarVisible: false,
        autoRefreshInterval: null,
        notification:0,
      };
    },
    created() {
      this.loadDashboardData();
      this.refreshEventFeed(); // Load the event feed when the page is created
      this.checkNotification();
    },
    mounted() {
      // 10초마다 새로고침 설정
      this.autoRefreshInterval = setInterval(() => {
        this.loadDashboardData();
        this.refreshEventFeed();
        this.checkTagActiveStatus();
        this.checkGatewayActiveStatus();
        // this.checkWebsocketActiveStatus();
        this.checkNotification();
        this.checkWebNoti();
      }, 10000);
      
      // 데이터 로드 후 차트 렌더링
      this.loadDashboardData();
      setTimeout(() => {
        this.renderChart();
      }, 1000); // 1초 후 차트 렌더링
    },
    beforeUnmount() {
      // 컴포넌트가 언마운트되기 전에 인터벌 해제
      clearInterval(this.autoRefreshInterval);
    },
    watch: {
      totalAssets: 'renderChart',
      activeAssets: 'renderChart',
      inactiveAssets: 'renderChart',
      highTempAssets: 'renderChart',
      lowTempAssets: 'renderChart',
      lowBatteryAssets: 'renderChart'
    },
    methods: {
      getCompanyLogo() {
        const company = localStorage.getItem('company');
        return require(`@/assets/${company}_LOGO.png`);
      },
      loadDashboardData() {
        const company = localStorage.getItem('company');
        // dashboardOld API가 작동하지 않을 경우를 대비해 기존 dashboard API도 시도
        axios.get('/api/dashboardOld', { params: { company } }).then((response) => {
          const data = response.data;
          this.totalAssets = data.totalAssets;
          this.activeAssets = data.activeAssets;
          this.inactiveAssets = data.inactiveAssets;
          this.highTempAssets = data.highTempAssets;
          this.lowTempAssets = data.lowTempAssets;
          this.lowBatteryAssets = data.lowBatteryAssets;
          this.checkTagActiveStatus();
          this.checkGatewayActiveStatus();
          // this.checkWebsocketActiveStatus();
        })
        .catch((error) => {
          console.error('Failed to load dashboardOld data, trying dashboard API:', error);
          // dashboardOld API 실패 시 기존 dashboard API 시도
          axios.get('/api/dashboard', { params: { company } }).then((response) => {
            const data = response.data;
            this.totalAssets = data.totalAssets;
            this.activeAssets = data.activeAssets;
            this.inactiveAssets = data.inactiveAssets;
            this.highTempAssets = data.highTempAssets;
            this.lowTempAssets = data.lowTempAssets;
            this.lowBatteryAssets = data.lowBatteryAssets;
            this.checkTagActiveStatus();
            this.checkGatewayActiveStatus();
          }).catch((dashboardError) => {
            console.error('Failed to load dashboard data:', dashboardError);
            // 기본값 설정
            this.totalAssets = 0;
            this.activeAssets = 0;
            this.inactiveAssets = 0;
            this.highTempAssets = 0;
            this.lowTempAssets = 0;
            this.lowBatteryAssets = 0;
          });
        });
      },
      renderChart() {
        if (this.chart) {
          this.chart.destroy();
        }
  
        const ctx = this.$refs.pieChart.getContext('2d');
        this.chart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['Active', 'Inactive'],
            datasets: [{
              data: [
                this.activeAssets,
                this.inactiveAssets,
              ],
              backgroundColor: [ '#4a90e2', '#50e3c2', ]
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            cutout: '70%', // 가운데 비어있는 부분 크기 설정
            plugins: {
              legend: {
                position: 'left'
              },
              datalabels: {
                formatter: (value, context) => {
                  const dataset = context.chart.data.datasets[0].data;
                  const total = dataset.reduce((acc, val) => acc + val, 0);
                  const percentage = ((value / total) * 100).toFixed(1);
                  return percentage + '%';
                },
                color: '#fff',
                font: {
                  weight: 'bold'
                }
              }
            }
          }
        });
      },
      refreshEventFeed() {
        axios.get('/api/getEventFeed').then((response) => {
          // 최신순으로 정렬한 뒤, 상위 20개만 선택
          this.events = response.data
            .sort((a, b) => new Date(b.updatetime) - new Date(a.updatetime))
            .slice(0, 10);
        }).catch(error => {
          console.error('Failed to load event feed:', error);
        });
      },
      checkNotification(){
        const company = localStorage.getItem('company');
        axios.get('/api/getNotification', { params: { company } }).then((response)=>{
          const data = response.data;
          this.notification = data.notification;
          console.log(response.data);
        }).catch(error => {
          console.error('Failed to load notification:', error);
        });
      },
      checkTagActiveStatus() {
        axios.post('/api/checkactive/tag').then((response) => {
          console.log('Tag Active 상태가 업데이트되었습니다:', response.data.message);
        }).catch(error => {
          console.error('Failed to check active status:', error);
        });
      },
      checkGatewayActiveStatus() {
        axios.post('/api/checkactive/gateway').then((response) => {
          console.log('Gateway Active 상태가 업데이트되었습니다:', response.data.message);
        }).catch(error => {
          console.error('Failed to check active status:', error);
        });
      },
      checkWebNoti(){
        const company = localStorage.getItem('company');
        axios.get('/api/checkWebNoti', { params: { company } }).then((response) => {
          console.log('Web Notification 상태가 업데이트되었습니다:', response.data.message);
        }).catch(error => {
          console.error('Failed to check active status:', error);
        });
      },
      // checkWebsocketActiveStatus(){
      //   axios.post('/api/checkactive/ws/all').then((response) => {
      //     console.log('Websocket Active 상태가 업데이트되었습니다:', response.data.message);
      //   }).catch(error => {
          // console.error('Failed to check active status:', error);
        // });
      // },
      goToNotification(){
        this.$router.push({ path: '/notificationCenter'});
      },
      goToAssetPage(filter) {
        this.$router.push({ path: '/assetPage', query: { filter } });
      },
      goToAnomalyAssets(filter) {
        this.$router.push({ path: '/assetList', query: { filter } });
        console.log("Navigating to assetList with filter:", filter);
      },
      openSidebar(tag_mac) {
        axios.get(`/api/getEventMac?tag_mac=${tag_mac}`).then(response => {
          this.selectedAsset = response.data; // 선택된 자산 정보 저장
          this.isSidebarVisible = true; // 사이드바 표시
        }).catch(error => {
          console.error('Failed to retrieve asset details:', error);
        });
      },
      closeSidebar() {
        this.isSidebarVisible = false; // 사이드바 숨김
        this.selectedAsset = null; // 선택된 자산 초기화
      },
      getStatusMessage(usercheck) {
        if (usercheck === 0) {
          return `slept `;
        } else if (usercheck === 2) {
          return `woken up `;
        }
        return '';
      },
      formatDateTime(dateTime) {
        const date = new Date(dateTime);
        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        };
        return date.toLocaleString('en-US', options);
      },
      getMapUrl() {
        const company = localStorage.getItem('company');
        const mapUrls = {
          'KAVALAN': 'https://www.google.com/maps/d/embed?mid=1FMOhkG2i6Wa8J0y0pdKC9W3SyFDLsNo',
          'AmericanWineries': 'https://www.google.com/maps/d/embed?mid=15u0w1fH0oT_45UMACw2l7j5esZ7DjPU',
          'PNK': 'https://www.google.com/maps/d/embed?mid=1BMVwYoo_9xAjv6rB85BwKqAZCnBKkqc',
          'Wintest': 'https://www.google.com/maps/d/embed?mid=1kdsctzWVCxIPdpEGU6kMCJ2p4frOShM',
          'OTOKI': 'https://www.google.com/maps/d/embed?mid=1FMOhkG2i6Wa8J0y0pdKC9W3SyFDLsNo' // OTOKI용 맵 URL 추가
        };
        
        return mapUrls[company] || mapUrls['KAVALAN']; // 기본값으로 KAVALAN 맵 반환
      },
      goToAssetMap() {
        this.$router.push({ path: '/assetMap' });
      },
      goToTagList() {
        this.$router.push({ path: '/tagList' });
      },
      goToGatewayList() {
        this.$router.push({ path: '/gatewayList' });
      },
      goToTagListWithFilter(prefix) {
        // 현재 경로가 /tagList인지 확인
        if (this.$route.path === '/tagList') {
          // 이미 TagList 페이지에 있으면 쿼리만 업데이트
          this.$router.replace({ path: '/tagList', query: { filter: prefix } });
        } else {
          // 다른 페이지에서 TagList로 이동
          this.$router.push({ path: '/tagList', query: { filter: prefix } });
        }
      },
    },
  };
  </script>
  <style scoped>
  .dashboard-container {
    padding: 5px 10px; /* 좌우 패딩을 더 줄여서 카드가 더 넓어 보이게 */
    max-width: 1680px; /* 1400px에서 1680px로 20% 증가 */
    margin: 0 auto;
    overflow-x: hidden;
  }
  
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
  }
  
  /* 새로운 Asset Cards 스타일 */
  .asset-cards-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    margin-bottom: 20px;
  }
  
  .asset-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid rgba(0, 0, 0, 0.05);
  }
  
  .asset-card:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
  
  .card-header {
    font-size: 14px;
    font-weight: 600;
    color: #666;
    margin-bottom: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .card-value {
    font-size: 42px;
    font-weight: 700;
    color: #333;
    line-height: 1;
  }
  
  /* 각 카드별 색상 */
  .asset-card:nth-child(1) .card-value {
    color: #4e73df; /* Total Asset - 파란색 */
  }
  
  .asset-card:nth-child(2) .card-value {
    color: #1cc88a; /* Active Assets - 초록색 */
  }
  
  .asset-card:nth-child(3) .card-value {
    color: #36b9cc; /* Inactive Assets - 청록색 */
  }
  
  /* Chart and Map Cards 컨테이너 */
  .chart-map-cards-container {
    display: grid;
    grid-template-columns: 2fr 1fr; /* Asset Map 2 : Asset Chart 1 비율 */
    gap: 15px;
    margin-bottom: 20px;
  }
  
  /* Chart and Map Card 스타일 */
  .chart-map-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    border: 1px solid rgba(0, 0, 0, 0.05);
  }
  
  .chart-map-card:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
  
  .clickable-card {
    cursor: pointer;
  }
  
  .clickable-card:hover {
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2) !important;
    transform: translateY(-3px) !important;
  }
  
  .chart-map-card .card-header {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  /* Chart Container 스타일 */
  .chart-container {
    width: 100%;
    height: 320px;
    position: relative;
    overflow: hidden;
  }
  
  /* Dashboard Map Container 스타일 */
  .dashboard-map-container {
    width: 100%;
    height: 320px;
    overflow: hidden;
    border-radius: 8px;
  }
  
  .sleep-message {
    color: green; /* 초록색 */
    font-weight: bold;
  }
  
  .woke-up-message {
    color: red; /* 빨간색 */
    font-weight: bold;
  }
  .devicename{
    color: rgb(238, 167, 36);
    font-weight: bold;
  }
  .feed-map-container {
    display: flex;
    gap: 20px;
    margin-top: 0px; /* 상단 여백 제거 */
    width: 100%; /* 컨테이너 전체 너비 사용 */
  }
  
  .half-width {
    flex: 1; /* 균등하게 공간 분배 */
    min-width: 0; /* 내용이 넘칠 때 줄어들 수 있도록 설정 */
  }
  
  .map-frame {
    border-radius: 10px;
  }
  .widget-notification-info{
    flex: 3;
    padding: 10px 20px;
    border: 2px solid #a8a8aa;
    border-radius: 10px;
    background-color: #fff;
    /* justify-content: left; */
    align-items: center;
    justify-content: center;
  }
  .notification-card-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .notification-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ca1305;
    color: white;
    padding: 20px;
    border-radius: 10px;
    text-align: left;
    width: 90%;
    cursor: pointer;
    position: relative;
    height: 110px;
  }
  .notification-icon {
    font-size: 40px;
  }
  
  .notification-info {
    text-align: right;
  }
  
  .notification-count {
    font-size: 48px;
    font-weight: bold;
    color: #fff;
  }
  .notification-card-title {
    font-size: 18px;
    font-weight: bold;
    margin: 5px 0 0 0;
    color: #fff;
  }
  .notification-card-subtitle {
    font-size: 14px;
    color: #fff;
  }
  .view-details-button {
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
    border: none;
    border-radius: 5px;
    padding: 8px 16px;
    font-size: 14px;
    margin-top: 10px;
    cursor: pointer;
    text-transform: uppercase;
    position: absolute;
    bottom: 10px;
    width: 100%;
  }
  
  .view-details-button:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
  .widget-chart-2{
    display:flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  
  .temperature-chart {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    overflow: hidden;
    width: 100%; /* 너비 100%로 설정 */
  }
  
  /* 반응형 디자인을 위한 미디어 쿼리 */
  @media screen and (min-width: 1600px) {
    .dashboard-container {
      max-width: 1800px; /* 큰 화면에서는 더 넓게 */
      padding: 5px 15px;
    }
  }
  
  @media screen and (max-width: 1200px) {
    .dashboard-container {
      max-width: 100%;
      padding: 5px 8px;
    }
    
    .asset-cards-container {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
    }
    
    .chart-map-cards-container {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
  
  @media screen and (max-width: 768px) {
    .dashboard-container {
      padding: 3px; /* 모바일에서 패딩을 더 최소화 */
    }
    
    .asset-cards-container {
      grid-template-columns: 1fr;
      gap: 10px;
    }
    
    .chart-map-cards-container {
      grid-template-columns: 1fr;
      gap: 10px;
    }
    
    .asset-card {
      padding: 15px;
    }
    
    .chart-map-card {
      padding: 15px;
    }
    
    .card-value {
      font-size: 32px;
    }
    
    .chart-container,
    .dashboard-map-container {
      height: 280px;
    }
  }
  
  /* Dashboard Component Container 스타일 추가 */
  .dashboard-component-container {
    width: 100%;
    height: 500px; /* 400px에서 500px로 더 증가 */
    overflow: hidden;
    border-radius: 8px;
    border: 1px solid #e0e0e0; /* 경계선 추가 */
    display: flex;
    flex-direction: column;
  }
  .sdaa-card {
    background: white;
    border: 2px solid #f6f7f7;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .sdaa-card-header {
    font-size: 2.2rem !important;
    font-weight: 800;
    color: #333 !important;
    letter-spacing: 2px;
    background: none !important;
    margin-bottom: 0;
    text-transform: none;
  }
  .sdaa-card:hover {
    background: #f8f9fa;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    transform: translateY(-4px);
  }
  </style>
  